import React, { useState } from 'react';
import './CustomizeTripComponent.css';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  Add,
  ApartmentRounded,
  EmojiTransportationRounded,
  FlightTakeoffOutlined,
  PeopleAltOutlined,
  Remove
} from '@mui/icons-material';
import { TransportationOptions } from '../../../constants/SelectedVacationSpotConstant';
import StarVector from '../../../assets/images/Start_Vector.jpg';
import buttonEndIcon from '../../../assets/icons/button-end.svg';

const CustomizeTrip = ({ setTotalPax, handleCustomTripTab, whoTravelling }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [formValues, setFormValues] = useState({
    adults: whoTravelling === 'Solo' ? 1 : whoTravelling === 'Couple' ? 2 : 0,
    infants: 0,
    children: 0,
    hotelRating: '5',
    includeFlights: true,
    transportationType: ''
  });

  const handleValueChange = (field, operation) => {
    setFormValues((prevValues) => {
      const newValue = parseInt(prevValues[field], 10) + (operation === 'increment' ? 1 : -1);
      return {
        ...prevValues,
        [field]: Math.max(newValue, 0)
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const existingTripDetails = JSON.parse(sessionStorage.getItem('tripDetails')) || {};
    const updatedTripDetails = {
      ...existingTripDetails,
      tripMembers: formValues
    };
    sessionStorage.setItem('tripDetails', JSON.stringify(updatedTripDetails));
    const totalPax =
      parseInt(formValues.adults) + parseInt(formValues.children) + parseInt(formValues.infants);
    setTotalPax(totalPax);
    handleCustomTripTab();
  };

  return (
    <Box
      sx={{
        maxWidth: isMobile ? '100%' : '400px',
        margin: isMobile ? '0' : 'auto',
        padding: '20px',
        backgroundColor: 'white',
        boxShadow: 3,
        borderRadius: '8px'
      }}>
      <form
        onSubmit={handleSubmit}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Grid container pb={3} justifyContent="center">
          <Grid className="filed-row" item display="flex">
            <Icon>
              <PeopleAltOutlined />
            </Icon>
            <Typography className="lable-title" mx={1}>
              No. of members
            </Typography>
          </Grid>
          {['Adults', 'Children', 'Infants'].map((label) => (
            <Grid
              key={label}
              className="filed-row"
              item
              display="flex"
              justifyContent="space-between"
              pt={2}
              sx={{ marginBottom: '16px' }}>
              <Typography
                className="lable-title-2nd"
                component="span"
                sx={{ lineHeight: '1.5', paddingRight: '0px' }}>
                {label}
                <Typography
                  className="label-sub-title"
                  component="span"
                  sx={{
                    paddingBottom: label === 'Adults' || label === 'Children' ? '8px' : '0px',
                    lineHeight: '1.5',
                    paddingLeft: '10px'
                  }}>
                  {(() => {
                    let labelText =
                      label === 'Adults'
                        ? 'Above 12 years'
                        : label === 'Children'
                        ? 'Ages 2-12 years'
                        : 'Below 2 years';

                    return labelText.length > 16 ? labelText.slice(0, 16) + '...' : labelText;
                  })()}
                </Typography>
              </Typography>
              <Box className="count-box" sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  onClick={() => handleValueChange(label.toLowerCase(), 'decrement')}
                  disabled={formValues[label.toLowerCase()] === 0}
                  sx={{
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform:
                        !isMobile && formValues[label.toLowerCase()] > 0 ? 'scale(1.2)' : 'none'
                    }
                  }}>
                  <Remove />
                </IconButton>
                <Typography className="count-box-number">
                  {formValues[label.toLowerCase()]}
                </Typography>
                <IconButton
                  onClick={() => handleValueChange(label.toLowerCase(), 'increment')}
                  sx={{
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: !isMobile ? 'scale(1.2)' : 'none'
                    }
                  }}>
                  <Add />
                </IconButton>
              </Box>
            </Grid>
          ))}
        </Grid>

        <hr className="hr-line" />
        <Grid container justifyContent="center">
          <Grid className="filed-row" item display="flex">
            <Icon>
              <ApartmentRounded />
            </Icon>
            <Typography className="lable-title" mx={1}>
              Preferred Hotel Rating
            </Typography>
          </Grid>
          <Grid
            className="filed-row"
            item
            display="flex"
            sx={{ overflowX: 'auto', overflowY: 'hidden' }}>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                row
                value={formValues.hotelRating}
                onChange={(e) => setFormValues({ ...formValues, hotelRating: e.target.value })}
                sx={{
                  flexWrap: 'nowrap',
                  justifyContent: 'space-between',
                  width: 'max-content'
                }}>
                {[5, 4].map((rating) => (
                  <FormControlLabel
                    key={rating}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          '&:hover': {
                            transform: !isMobile ? 'scale(1.2)' : 'none'
                          },
                          '&.Mui-checked:hover': {
                            color: !isMobile ? '#FF5722' : 'inherit'
                          }
                        }}
                      />
                    }
                    label={
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          transition: 'transform 0.2s',
                          transform: !isMobile ? 'scale(1)' : 'none',
                          '&:hover': {
                            transform: !isMobile ? 'scale(1.2)' : 'none'
                          }
                        }}>
                        <span
                          className="rating-text"
                          style={{
                            fontSize: '14px',
                            marginRight: '4px',
                            transition: 'transform 0.2s',
                            transform: !isMobile ? 'scale(1)' : 'none'
                          }}>
                          {rating}
                        </span>
                        <img
                          src={StarVector}
                          alt="star"
                          style={{
                            width: '16px',
                            height: '16px',
                            transition: 'transform 0.2s',
                            transform: !isMobile ? 'scale(1)' : 'none'
                          }}
                        />
                      </div>
                    }
                    value={rating.toString()}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>

        <hr className="hr-line" />
        <Grid container justifyContent="center" mb={2}>
          <Grid className="filed-row" item display="flex">
            <Icon>
              <FlightTakeoffOutlined />
            </Icon>
            <Typography className="lable-title" mx={1}>
              Include Flights
            </Typography>
          </Grid>
          <Grid className="filed-row" item display="flex">
            <FormControlLabel
              control={
                <Radio
                  checked={formValues.includeFlights}
                  onChange={() => setFormValues({ ...formValues, includeFlights: true })}
                  sx={{
                    '&:hover': {
                      transform: !isMobile ? 'scale(1.2)' : 'none'
                    },
                    '&.Mui-checked:hover': {
                      color: !isMobile ? '#FF5722' : 'inherit'
                    }
                  }}
                />
              }
              label="Yes"
            />
            <FormControlLabel
              control={
                <Radio
                  checked={!formValues.includeFlights}
                  onChange={() => setFormValues({ ...formValues, includeFlights: false })}
                  sx={{
                    '&:hover': {
                      transform: !isMobile ? 'scale(1.2)' : 'none'
                    },
                    '&.Mui-checked:hover': {
                      color: !isMobile ? '#FF5722' : 'inherit'
                    }
                  }}
                />
              }
              label="No"
            />
          </Grid>
        </Grid>

        <hr className="hr-line" />
        <Grid container justifyContent="center" mb={2}>
          <Grid className="filed-row" item display="flex">
            <Icon>
              <EmojiTransportationRounded />
            </Icon>
            <Typography className="lable-title" mx={1}>
              Transportation Type
            </Typography>
          </Grid>
          <Grid className="filed-row" item display="flex" sx={{ width: '100%' }}>
            <FormControl fullWidth>
              <InputLabel id="transportation-type-label">Select Type</InputLabel>
              <Select
                labelId="transportation-type-label"
                value={formValues.transportationType}
                onChange={(e) =>
                  setFormValues({ ...formValues, transportationType: e.target.value })
                }
                label="Transportation Type"
                MenuProps={{
                  PaperProps: {
                    style: {
                      height: 'unset',
                      maxHeight: '120px',
                      overflowY: 'auto',
                      WebkitOverflowScrolling: 'touch'
                    }
                  }
                }}
                sx={{
                  '& .MuiSelect-icon': {
                    transition: 'transform 0.2s',
                    transform: !isMobile ? 'scale(1)' : 'none'
                  }
                }}>
                {TransportationOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Box className="filed-row" mt={3}>
          <Button
            type="submit"
            variant="contained"
            color="error"
            fullWidth
            disabled={formValues.adults === 0 || formValues.adults === '0'}
            sx={{
              backgroundColor: '#d32f2f',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#c62828'
              },
              '&:disabled': {
                backgroundColor: '#d32f2f',
                color: '#fff',
                opacity: 0.5
              }
            }}>
            Continue
            <Box
              component="img"
              src={buttonEndIcon}
              sx={{ width: 26, height: 26, ml: 2 }}
              alt="detail"
            />
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CustomizeTrip;
